<template>
  <div id="creator_user">
    <van-nav-bar :title="$t('title.creator_center')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="22" offset="1" class="creator_user-information">
        <van-col span="24">
          <van-col span="5"  class="creator_agency_information_bg_border_img">
            <van-image
                round
                width="12vw"
                height="12vw"
                :src="creator_user.head_image"
            />
          </van-col>
          <van-col span="10">
            <van-col span="24" class="creator_agency_information_bg_border_name"> {{ creator_user.nick_name }} </van-col>
            <van-col span="24" class="creator_agency_information_bg_border_id"> ID:<span id="creator_user_id">{{ creator_user.id }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId()"/> </van-col>
          </van-col>
          <van-col span="9" class="creator_user_information_time">
            <van-cell :value="date_text" arrow-direction="down" @click="dateShow = true" is-link/>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="creator_agency_yellow">
        <van-col span="24" class="creator_agency_yellow_bg">
          <span>{{ $t('column.total')}}:</span><img src="../assets/img/coin9.png"/><span class="creator_agency_yellow_bg_coin"> {{ total }}</span>
        </van-col>
        <van-col span="24">
          <van-col span="12" class="creator_agency_yellow_bg_left">
            <van-col span="24" class="creator_agency_yellow_bg_left_name">{{ $t('column.basic_income')}} </van-col>
            <van-col span="24" class="creator_agency_yellow_bg_left_val"><img src="../assets/img/coin9.png"/> {{ basic_income }}</van-col>
          </van-col>
          <van-col span="12" class="creator_agency_yellow_bg_left">
            <van-col span="24" class="creator_agency_yellow_bg_left_name">{{ $t('column.bonus_ncome')}} </van-col>
            <van-col span="24" class="creator_agency_yellow_bg_left_val"><img src="../assets/img/coin9.png"/> {{ bonus_income }}</van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="creator_user_agency">
        <van-col span="5" offset="1" class="creator_user_agency_title">{{ $t('column.my_agency')}}</van-col>
        <van-col span="9" class="creator_user_agency_centent">
          <van-image
              round
              width="8vw"
              height="8vw"
              :src="creator_user.agency_head_image"
          />{{ creator_user.agency_name }}
        </van-col>
        <van-col span="9" class="creator_user_agency_cell">
          <van-cell :value="$t('column.change_agency')" is-link @click="jumpBtn()"/>
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="creator_user_guanggao">
        <img src="../assets/img/creator/creator_user_guanggao.png" @click="jumpCommissionBtn()"/>
      </van-col>

      <van-col span="24" class="creator_user_tab">
        <van-tabs v-model="creator_active">
          <!--    每日收益      -->
          <van-tab :title="$t('column.daily_income')">
            <van-col span="22" offset="1" class="creator_user_daily_income" v-for="(item,i) in daily_income_list" :key="i">
              <van-col span="22" offset="1" class="creator_user_daily_income_time">
                <van-cell :title="item.date" is-link @click="jumpDaily(item.date_ymd)"/>
              </van-col>
              <van-col span="22" offset="1" class="creator_user_daily_income_time">
                <van-col span="8">
                  <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.total')}}</van-col>
                  <van-col span="24" class="creator_user_daily_income_time_coin"> <img src="../assets/img/coin9.png"/>{{ item.total }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.basic_income')}}</van-col>
                  <van-col span="24" class="creator_user_daily_income_time_coin2"> <img src="../assets/img/coin9.png"/>{{ item.basic_income }}</van-col>
                </van-col>
                <van-col span="8">
                  <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.bonus_ncome')}}</van-col>
                  <van-col span="24" class="creator_user_daily_income_time_coin2"> <img src="../assets/img/coin9.png"/>{{ item.bonus_ncome }}</van-col>
                </van-col>
              </van-col>
            </van-col>
          </van-tab>
          <van-tab :title="$t('column.room_data')">
            <!-- 房间收益 -->
            <van-col span="22" offset="1" class="creator_user_tab_buttons">
              <van-col span="8" class="creator_user_tab_button" :class="{'creator_user_tab_active': room_type_tab === 'live'}" @click="room_type_tab = 'live'">
                {{ $t('column.live_room')}}
              </van-col>
              <van-col span="8" offset="1" class="creator_user_tab_button" :class="{'creator_user_tab_active': room_type_tab === 'chat'}" @click="room_type_tab = 'chat'">
                {{ $t('column.chat_room')}}
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="creator_user_data_table" v-if="room_type_tab === 'live'">
              <!-- 表头 -->
              <van-col span="24" class="creator_user_data_table_header">
                <van-col span="7" offset="1" class="creator_user_data_table_header_cell">{{ $t('column.date') }}</van-col>
                <van-col span="7" class="creator_user_data_table_header_cell2">{{ $t('column.live_duration')}} <br/> ({{ $t('column.mins')}})</van-col>
                <van-col span="8" class="creator_user_data_table_header_cell2">{{ $t('column.live_room_gift')}} </van-col>
              </van-col>
              <!-- 表数据 -->
              <van-col span="24" class="creator_user_table_body">
                <van-col span="23" offset="1" class="creator_user_table_body_row" v-for="(item, index) in live_room_income_list" :key="index">
                  <van-col span="7" class="creator_user_table_body_cell">{{ item.date }}</van-col>
                  <van-col span="7" class="creator_user_table_body_cell2">{{ item.duration }}</van-col>
                  <van-col span="9" class="creator_user_table_body_cell2">
                    <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.bonus_income }}
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="creator_user_data_table" v-else>
              <!-- 表头 -->
              <van-col span="24" class="creator_user_data_table_header">
                <van-col span="7" offset="1" class="creator_user_data_table_header_cell">{{ $t('column.date') }}</van-col>
                <van-col span="7" class="creator_user_data_table_header_cell2">{{ $t('column.mic_duration')}} <br/> ({{ $t('column.mins')}})</van-col>
                <van-col span="8" class="creator_user_data_table_header_cell2">{{ $t('column.chat_room_gift')}}</van-col>
              </van-col>
              <!-- 表数据 -->
              <van-col span="24" class="creator_user_table_body">
                <van-col span="23" offset="1" class="creator_user_table_body_row" v-for="(item, index) in room_income_list" :key="index">
                  <van-col span="7" class="creator_user_table_body_cell">{{ item.date }}</van-col>
                  <van-col span="7" class="creator_user_table_body_cell2">{{ item.duration }}</van-col>
                  <van-col span="9" class="creator_user_table_body_cell2">
                    <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.bonus_income }}
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
          </van-tab>
        </van-tabs>
      </van-col>
    </van-row>

    <van-popup v-model="dateShow" position="bottom" :style="{ height: '40%',width: '100%' }">
      <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          :max-date="maxDate"
          :title="$t('column.select_date')"
          :confirm-button-text="$t('btn.confirm')"
          :cancel-button-text="$t('btn.cancel')"
          @confirm="onConfirmDate"
          @cancel="dateShow = false"
      />
    </van-popup>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import uploadImage from '@/components/upload_image.vue';
import {Dialog, DatetimePicker} from "vant";

export default {
  components: { uploadImage, DatetimePicker },
  data() {
    return {
      creator_active: 0,
      room_type_tab: 'live', // 'live' 或 'chat'
      daily_income_list: [],
      room_income_list: [],
      live_room_income_list: [],
      creator_user:{},
      total: 0,
      basic_income: 0,
      bonus_income: 0,
      dateShow: false,
      date: '',
      date_text: '',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(new Date().setHours(23,59,59,999)),
      currentDate: new Date(),
    }
  },
  created() {
    this.getMonths(this.currentDate.getMonth());
    let year = this.currentDate.getFullYear();
    let month = this.currentDate.getMonth() + 1;
    this.date = year + '-' + month
    this.getList()
    this.incomelist()
  },
  methods: {
    getMonths(monthNumber){
      // 获取月份数字（1-12）
      const months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      // 获取月份名称
      this.date_text = months[monthNumber];
    },
    onConfirmDate(time) {
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      this.date = year + '-' + month
      this.getMonths(time.getMonth())
      console.log(this.date)
      this.incomelist()
      this.dateShow = false
    },
    jumpBtn() {
      // 跳转
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/my_agency', query: {uid: uid, token: token}})
    },
    jumpCommissionBtn() {
      // 跳转
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/creator_user_commission', query: {uid: uid, token: token}})
    },
    jumpDaily(date) {
      // 跳转
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/creator_daily_income', query: {uid: uid, token: token, date: date}})
    },
    copyId() {
      const element = document.getElementById("creator_user_id");
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    incomelist() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_center_income",{
        params:{uid: uid, token: token, date: this.date}
      }).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.daily_income_list = res.data.data.daily_income_list
          this.room_income_list = res.data.data.room_income_list
          this.live_room_income_list = res.data.data.live_room_income_list
          this.total = res.data.data.total
          this.basic_income = res.data.data.basic_income
          this.bonus_income = res.data.data.bonus_income
        }else{
          Toast(res.data.error)
        }
      })
    },
    getList(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_center",{
        params:{uid: uid, token: token}
      }).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.creator_user = res.data.data
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/creator_user.vue